import * as React from 'react';
import { Card, Box, Button, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import Dashboard from '../dashboard';

const FileNotFound: React.FC = () => {
  const theme = useTheme();

  return (
    <Dashboard>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 66px)',
          width: '100%',
        }}
      >
        <Card
          sx={{
            padding: { xs: 2, sm: 3 },
            textAlign: 'center',
            borderRadius: '8px',
            border: `1px solid ${theme.palette.secondary.light}`,
            backgroundColor: theme.palette.background.paper,
            maxWidth: { xs: '90%', sm: '80%', md: '60%', lg: '50%' },
            margin: 'auto',
          }}
        >
          <Box
            component="h2"
            sx={{
              color: theme.palette.text.primary,
              marginBottom: { xs: 1, sm: 2 },
              fontWeight: 'normal',
              fontSize: { xs: '1.25rem', sm: '1.5rem' },
            }}
          >
            File Not Found
          </Box>
          <Box
            sx={{
              color: theme.palette.text.secondary,
              fontSize: { xs: '0.8rem', sm: '0.875rem' },
              marginBottom: { xs: 2, sm: 3 },
              px: { xs: 1, sm: 2 },
            }}
          >
            The requested file could not be located. Please check the URL and
            try again.
          </Box>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/dashboard"
          >
            Go back to Dashboard
          </Button>
        </Card>
      </Box>
    </Dashboard>
  );
};

export default FileNotFound;
